module.exports = __webpack_public_path__ + "img/adorno1.2c371ab8.svg";